<fieldset>
  @if (label) {
    <label [raskRequired]="required">
      {{label}}
      @if (infoText) {
        <rask-info>{{infoText}}</rask-info>
      }
    </label>
  }
  @for (item of checkboxItems; track item) {
    <rask-checkbox-item
      [label]="item.text"
      [disabled]="disabled"
      [attr.disabled]="disabled ? '' : null"
      [key]="item.text"
      (checkedChange)="changed($event)"
      [checked]='item.value'>
    </rask-checkbox-item>
  }
  @if (rule) {
    <rask-validation-message [rule]="rule"></rask-validation-message>
  }
</fieldset>

